<template>
  <div class="services-section">
    <LayoutSection size="o5v90">
      <PreviousPageBtn :label-code="previoueBtnName" :class="'mt-40'" />
      <el-row>
        <el-col class="text-left p-9" :xs="12" :sm="8" :md="8">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="servicesImage" class="services-image" />
          </div>
        </el-col>
        <el-col class="text-left p-9 faq-tile" :xs="12" :sm="16" :md="16">
          <h2 class="mb-13 text-left page-title mt-150">
            {{ $t("faq.ordersDeliveries.title") }}
          </h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :offset="6" class="mt-50">
          <el-tabs v-model="tabActiveName">
            <el-tab-pane
              :label="$i18n.t('faq.ordersDeliveries.tabList.commander')"
              name="first"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="commander in commanderQuestion"
                  :key="commander.question"
                  :title="commander.question"
                  :name="commander.question"
                >
                  <div v-html="commander.answer" class="text-left answer"></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane
              :label="$i18n.t('faq.ordersDeliveries.tabList.problems')"
              name="second"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="problems in problemsQuestion"
                  :key="problems.question"
                  :title="problems.question"
                  :name="problems.question"
                >
                  <div v-html="problems.answer" class="text-left answer"></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane
              :label="$i18n.t('faq.ordersDeliveries.tabList.livraison')"
              name="third"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="livraison in livraisonQuestion"
                  :key="livraison.question"
                  :title="livraison.question"
                  :name="livraison.question"
                >
                  <div v-html="livraison.answer" class="text-left answer"></div>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
          </el-tabs>
          <h3
            class="mt-15"
            v-html="$i18n.t('faq.ordersDeliveries.tagLine')"
          ></h3>
        </el-col>
      </el-row>
    </LayoutSection>
  </div>
</template>

<script>
import LayoutSection from "@/components/layout/layout-section.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";

export default {
  components: {
    LayoutSection,
    PreviousPageBtn,
  },
  data() {
    return {
      previoueBtnName: "FrequentlyAskedQuestions",
      activeNames: ["Que veut dire Boires?"],
      tabActiveName: "first",
    };
  },
  computed: {
    servicesImage() {
      return require("@/assets/images/faq/services/services.png");
    },
    commanderQuestion() {
      return this.$i18n.t("faq.ordersDeliveries.commander");
    },
    problemsQuestion() {
      return this.$i18n.t("faq.ordersDeliveries.problems");
    },
    livraisonQuestion() {
      return this.$i18n.t("faq.ordersDeliveries.livraison");
    },
  },
  methods: {},
};
</script>

<style>
.services-section {
  margin-bottom: 50px;
}
.services-image {
  height: auto;
  width: 100%;
}
.faq-tile-desscription {
  margin-top: 10px;
}
.services-tile-title {
  font-size: 18px;
  font-weight: bold;
}
.el-collapse-item__header {
  font-size: 20px;
}
.answer {
  font-size: 15px;
}
.el-collapse {
  border-top: 0;
}
</style>
